import { system } from '@eastcoal/common/config/system'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AuctionDetailNavigator } from '@eastcoal/shared/components/AuctionDetailNavigator'
import { EntranceType } from '@eastcoal/shared/enums/EntranceType'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'

import { AuctionNavigateButtonProps } from './interface'

const AUCTION_DETAIL_PAGE_PATH = '/auction/detail'

export const AuctionNavigateButton = ({
  record: {
    id,
    bizType,
    title,
    status,
    entranceTicketId,
    entranceType = EntranceType.WATCH
  }
}: AuctionNavigateButtonProps) => {
  return (status === AuctionMemberPageStatus.WAIT_START ||
    status === AuctionMemberPageStatus.BIDDING) &&
    entranceTicketId ? (
    <AuctionDetailNavigator
      auctionTitle={title}
      bizId={id}
      bizType={bizType}
      entranceType={entranceType}
      type='link'
      to={stringifyUrl({
        url: system.router.mallBaseUrl + AUCTION_DETAIL_PAGE_PATH,
        query: { id, entranceType }
      })}
    />
  ) : null
}
